var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasketIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.722 3.199v10.014a2.187 2.187 0 01-2.177 2.176H3.457a2.188 2.188 0 01-2.179-2.176V3.199H.504c-.672 0-.672-1.02 0-1.02H4.48V1.2C4.48.56 4.98 0 5.633 0H8.37c.65 0 1.154.564 1.154 1.2v.979h3.973c.672 0 .672 1.02 0 1.02h-.774zM5.5 2.179h3V1.2c0-.075-.044-.18-.131-.18H5.633c-.089 0-.133.105-.133.18v.978zm3.723 9.34c0 .668-1.02.668-1.02 0V5.962c0-.67 1.02-.67 1.02 0v5.555zm-3.426 0c0 .668-1.02.668-1.02 0V5.962c0-.67 1.02-.672 1.02 0v5.555zm5.904-8.32h-9.4v10.014c0 .636.517 1.156 1.156 1.156h7.088c.637 0 1.156-.52 1.156-1.156V3.199z",
    fill: "#150223"
  })));
}
export default SvgBasketIcon;